/**
 * Generic pagination utility for fetching all pages of data in Vue module
 * 
 * @param {Function} fetchPageFn - Function that takes (params) and returns a promise with array of items
 * @param {Object} baseParams - Base parameters for the API call
 * @returns {Promise<Array>} - Array of all items across all pages
 */
const fetchAllPages = async (fetchPageFn, baseParams = {}) => {
  const perPage = baseParams.per_page || 30;
  const aggregated = [];
  
  const loadPage = async (page) => {
    const params = {
      ...baseParams,
      page,
      per_page: perPage,
    };
    
    try {
      const list = await fetchPageFn(params);
      aggregated.push(...list);
      
      if (list.length < perPage) {
        return aggregated;
      }
      return loadPage(page + 1);
    } catch (error) {
      console.error('Error fetching page:', page, error);
      throw error;
    }
  };
  
  return loadPage(1);
};

export default {
  fetchAllPages,
};
